

exports.__esModule = true;
exports.$PhoneConfirmationModel = void 0;
var _squid = require("squid");
var $PhoneConfirmationModel = exports.$PhoneConfirmationModel = _squid.$Model.extend('$PhoneConfirmationModel', {
  api: new _squid.$Api({
    uri: '/api/onboard/phoneConfirmation'
  }),
  init: function init() {
    this._super.init.apply(this);
  },
  serializeInitiateData: function serializeInitiateData() {
    return {
      phoneCountry: this.phoneCountry,
      phoneNumber: this.phoneNumber,
      locale: this.locale
    };
  },
  serializeConfirmData: function serializeConfirmData() {
    return {
      pin: this.pin,
      verificationId: this.verificationId
    };
  }
});
angular.value("$PhoneConfirmationModel", $PhoneConfirmationModel);
_squid.$Model;
_squid.$Api;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-models/src/phoneConfirmation/index.js
// module id = ../node_modules/xo-models/src/phoneConfirmation/index.js
// module chunks = 0